import { ConsiderCard } from "./Card"
import { DoubleContainer } from "./Container"
import { Separador } from "./Image"
import { Text } from "./Text"

export const DebesTenerEnCuentaSection = (props)=>{
    return(
        <>
        <Text 
            text={props.title} 
            marginTop='0'
            text-align= 'center'
            fontFamily='Damion-Regular' 
            fontSize='100px'
            color='#FF7C66'/>
        <Text
            text={props.subtitle}
            fontFamily='Montserrat-Regular'
            textAlign='left'
            fontSize='18px'
            color='#303030'/>
        <DoubleContainer>
            {props.data.map((data)=>(
                <ConsiderCard key={data.id}>
                    <Text
                        text={data.title}
                        textAlign='center'
                        fontFamily='Montserrat-Bold'
                        fontSize='25px'
                        color='#3D7699'/>
                    <Text
                        style={{
                            textAlign:'left',
                        }}
                        text={data.description}
                        fontFamily='Montserrat-Regular'
                        fontSize='18px'
                        color='#303030'/>
                </ConsiderCard>
            ))}
        </DoubleContainer>
        <Separador 
            src={props.separator}/>
        </>
    )
}